export default {
  SET_USER_LOCATION: 'SET_USER_LOCATION',
};
